import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/settings/user")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/account/profile" })
  },
})
